import { render } from "./FormenBewerter.vue?vue&type=template&id=276873f6"
import script from "./FormenBewerter.vue?vue&type=script&lang=js"
export * from "./FormenBewerter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__